var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.2C4.79675 2.2 2.2 4.79675 2.2 8C2.2 11.2033 4.79675 13.8 8 13.8C11.2033 13.8 13.8 11.2033 13.8 8C13.8 4.79675 11.2033 2.2 8 2.2ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z",
    fill: "#D9DBE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76164 6.06591C8.43545 5.73972 7.71786 5.70691 7.33529 6.34453C7.1648 6.62868 6.79624 6.72082 6.5121 6.55033C6.22795 6.37984 6.13581 6.01128 6.3063 5.72713C7.10628 4.39383 8.7538 4.36102 9.61017 5.21738C10.4466 6.05382 10.3523 7.36311 9.58951 8.05654C9.2633 8.3531 8.89877 8.49185 8.60335 8.5562V8.79513C8.60335 9.1265 8.33472 9.39513 8.00335 9.39513C7.67198 9.39513 7.40335 9.1265 7.40335 8.79513V8.22926C7.40335 7.74596 7.802 7.43548 8.18167 7.40777C8.35294 7.39527 8.59309 7.34062 8.7823 7.16861C9.04423 6.9305 9.10777 6.41204 8.76164 6.06591Z",
    fill: "#D9DBE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00332 9.76245C8.33469 9.76245 8.60332 10.0311 8.60332 10.3625V10.4019C8.60332 10.7332 8.33469 11.0019 8.00332 11.0019C7.67195 11.0019 7.40332 10.7332 7.40332 10.4019V10.3625C7.40332 10.0311 7.67195 9.76245 8.00332 9.76245Z",
    fill: "#D9DBE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpCircle);
export default __webpack_public_path__ + "static/media/icon-help-circle.19daae00aa702132d51ab7e1e8cf738f.svg";
export { ForwardRef as ReactComponent };